import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../services/auth.service';

/** Panel gerencial: solo rol administrador (`rol_id === 1`). El resto va a bienvenida. */
export const dashboardAdminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.esRolAdministrador()) return true;
  return router.createUrlTree(['/app/bienvenida']);
};
